import React, { useEffect, useState } from 'react'
import DocsUploadModal from '../components/docs-upload/docsUploadModal'
import { useAppDispatch } from '@library/utilities/hooks'
import { getUserData, getMerchantDetails } from '@store/user/selectors'
import { useSelector } from 'react-redux'
import { makeAPICall } from '@gokwik/utilities'
import APIEndPoints from '@library/utilities/constants/apiEndpoints'
import { getDocIconByName, getKycDoc } from '../utils'
import SampleDocumentPreview from '../components/docs-upload/sampleDocumentPreview'
import { DocumentPreviewModal } from '../components/docs-upload/docsPreviewModal'
import DocsStatusModal from '../components/docs-upload/docsStatusModal'
import { fetchUserDetails } from '@store/user'
import { NON_OCR_DOCS } from '../constants'

const ReuploadModal = ({ openUploadModal, setOpenUploadModal, mismatch_doc_name, setCurrentStep }) => {
    const userData = useSelector(getUserData)
    const dispatch = useAppDispatch()
    const [documentList, setDocumentList] = useState([])
    const [currentDoc, setCurrentDoc] = useState(null)
    const merchant_details = useSelector(getMerchantDetails)
    const [showPreview, setShowPreview] = useState(false)
    const [previewDoc, setPreviewDoc] = useState({})
    // const [openUploadModal, setOpenUploadModal] = useState(false)
    const [visible, setVisible] = useState(false)
    const [documentUrl, setDocumentUrl] = useState('')
    const [loadingAI, setLoadingAI] = useState(false)
    const [inputImageName, setInputImageName] = useState(null)
    const [openStatusModal, setOpenStatusModal] = useState(false)
    const [uploadProgress, setUploadProgress] = useState(0)
    const [isUploading, setIsUploading] = useState(false)
    const [uploadedFileName, setUploadedFileName] = useState('')
    const [ocrResult, setOcrResult] = useState([])
    const [resolvedErrors, setResolvedErrors] = useState<string[]>([])
    const [showLowScoreAlert, setShowLowScoreAlert] = useState(false)
    const [ocrApiError, setOcrApiError] = useState(false)
    const [uploadedFile, setUploadedFile] = useState(null)

    const onUploadClick = (doc) => {
        setCurrentDoc(doc)
        setOpenUploadModal(true)
    }

    const getDocumentList = async () => {
        let res = await makeAPICall({
            method: 'get',
            url: process.env.REACT_APP_BASE_URL + APIEndPoints.documentList,
            skipLoader: true,
        })

        groupBy(res.data.data)
    }

    function groupBy(dataArray) {
        const groupedData = []

        dataArray?.forEach((item) => {
            if (
                'uploaded' in item

                // userData?.merchantDetails?.onboarding_status?.kwik_checkout_app === 'kyc_verification_failed' &&
            ) {
                if (!item?.uploaded) {
                    sessionStorage.setItem('all_docs_uploaded', 'false')
                }
            }

            const obj = {}
            const title = item.title || 'Address Proof' // 'Others' is used for items without a title

            obj['title'] = title
            obj['label'] = item?.label
            obj['desc'] = item?.tooltip || ''
            obj['logo'] = getDocIconByName(item.name)
            obj['details'] = item
            obj['format_requirements'] = item?.format_requirements

            groupedData?.push(obj) // Append the item to the array for this title
        })

        setDocumentList(groupedData)
    }

    useEffect(() => {
        getDocumentList()
    }, [])

    useEffect(() => {
        if (documentList?.length > 0 && openUploadModal) {
            let doc = documentList?.find((item) => item?.details?.name === mismatch_doc_name)
            onUploadClick(doc)
        }
    }, [documentList, openUploadModal])

    const showSampleDoc = (doc) => {
        setShowPreview(true)
        setPreviewDoc(doc)
    }

    const handlePreview = (name) => {
        getKycDoc(name, setVisible, setDocumentUrl)
    }

    const deleteFile = async (name) => {
        await makeAPICall({
            method: 'post',
            url: process.env.REACT_APP_BASE_URL + APIEndPoints.deleteKycDocument,
            payload: {
                file_name: name,
            },
        }).then((res) => {
            getDocumentList()
        })
    }

    const handleDelete = async (item) => {
        setOcrResult(ocrResult?.filter((i) => i?.imageName !== item?.name))
        await deleteFile(item.name)
    }

    const handleImageUpload = async (image, imageName, setLoadingAI, setInputImageName, userData) => {
        if (!image) return

        setLoadingAI(true)
        setInputImageName(imageName)

        const response = await makeAPICall({
            url: process.env.REACT_APP_BASE_URL + APIEndPoints.openAIOCR,
            method: 'post',
            payload: { file: imageName },
            skipLoader: true,
        })

        if (response?.status === 200) {
            const aiResponse = response?.data?.data?.ai_response
            console.log('AI Response: ', aiResponse?.ai_response)
            setLoadingAI(false)
            return { aiResponse, imageName }
        } else {
            setOcrApiError(true)
            setLoadingAI(false)
            return { aiResponse: null, imageName: null }
        }
    }

    const handleImageChange = async (e, item) => {
        if (!NON_OCR_DOCS?.includes(item.name)) {
            const OcrResponse = await handleImageUpload(e, item?.name, setLoadingAI, setInputImageName, userData)

            setOcrResult((prev) => {
                const isDuplicate = prev.some(
                    (entry) =>
                        entry?.imageName === OcrResponse?.imageName &&
                        entry?.aiResponse?.doc_type === OcrResponse?.aiResponse?.doc_type,
                )
                return isDuplicate ? prev : [...prev, OcrResponse]
            })
        }
    }

    return (
        <>
            {showPreview && (
                <SampleDocumentPreview
                    isOpen={showPreview}
                    setIsOpen={setShowPreview}
                    previewDoc={previewDoc}
                    setPreviewDoc={setPreviewDoc}
                />
            )}
            {openUploadModal && currentDoc && (
                <DocsUploadModal
                    item={currentDoc}
                    visible={openUploadModal}
                    onClose={() => {
                        setOpenUploadModal(false)
                        setOcrResult([])
                        setShowLowScoreAlert(false)
                    }}
                    doc={currentDoc?.details}
                    getDocumentList={getDocumentList}
                    onShowSampleClick={showSampleDoc}
                    setIsUploading={setIsUploading}
                    setUploadedFileName={setUploadedFileName}
                    setOpenStatusModal={setOpenStatusModal}
                    setUploadProgress={setUploadProgress}
                    setOcrResult={setOcrResult}
                    ocrResult={ocrResult}
                    setLoadingAI={setLoadingAI}
                    setInputImageName={setInputImageName}
                    resolvedErrors={resolvedErrors}
                    setResolvedErrors={setResolvedErrors}
                    handleDelete={handleDelete}
                    showLowScoreAlert={showLowScoreAlert}
                    setOcrApiError={setOcrApiError}
                    handleImageChange={handleImageChange}
                    setUploadedFile={setUploadedFile}
                    ocrApiError={ocrApiError}
                    setShowLowScoreAlert={setShowLowScoreAlert}
                />
            )}
            {visible && (
                <DocumentPreviewModal
                    visible={visible}
                    onClose={() => setVisible(false)}
                    documentUrl={documentUrl}
                    documentName='document_name'
                />
            )}
            {openStatusModal && (
                <DocsStatusModal
                    item={currentDoc}
                    doc={currentDoc?.details}
                    ocrResult={ocrResult}
                    setOcrResult={setOcrResult}
                    visible={openStatusModal}
                    onClose={() => {
                        setOpenStatusModal(false)
                        setUploadProgress(0)
                        dispatch(fetchUserDetails())
                        localStorage.setItem('kyc_failure_current_step', '1')
                    }}
                    uploadProgress={uploadProgress}
                    uploadedFileName={uploadedFileName}
                    onShowSampleClick={showSampleDoc}
                    loadingAI={loadingAI}
                    openUploadModal={() => setOpenUploadModal(true)}
                    handlePreview={handlePreview}
                    isUploading={isUploading}
                    setCurrentDoc={setCurrentDoc}
                    handleDelete={handleDelete}
                    showLowScoreAlert={showLowScoreAlert}
                    setShowLowScoreAlert={setShowLowScoreAlert}
                    ocrApiError={ocrApiError}
                    handleImageChange={handleImageChange}
                    uploadedFile={uploadedFile}
                />
            )}
        </>
    )
}

export default ReuploadModal
